import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const StyledAccountGrid = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spaces[3],
}));

export const StyledAccountGridItem = styled.div<{ full?: boolean }>(({ full }) => ({
    gridColumn: 'span 2',
    [breakpoints.md]: {
        gridColumn: full ? 'span 2' : 'span 1',
    },
}));
